import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContextService, XenaClient } from 'src/app/services';
import { IFiscalSetupApprovalContext } from '../../dtos/fiscal-setup-approval-context';

@Injectable({
  providedIn: 'root'
})
export class FiscalSetupApprovalContextService {

  constructor(
    private xenaClient: XenaClient,
    protected context: ContextService
  ) { }

  get(): Observable<IFiscalSetupApprovalContext> {
    const path: string = `/Fiscal/${this.context.fiscalId}/FiscalSetup/ApprovalContext`;
    return this.xenaClient.get<IFiscalSetupApprovalContext>(path);
  }

  put(approvalContext: IFiscalSetupApprovalContext): Observable<IFiscalSetupApprovalContext> {
    const path: string = `/Fiscal/${this.context.fiscalId}/FiscalSetup/ApprovalContext`;
    return this.xenaClient.put<IFiscalSetupApprovalContext, IFiscalSetupApprovalContext>(path, approvalContext);
  }
}
